import React, { useState, useEffect } from 'react';
import api from '../../api/client';

const TYPES = {
  update: {
    label: 'Update',
    tone: 'bg-brand-500/12 border-brand-400/25 text-brand-200',
    icon: <><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M4 19h16" /></>,
  },
  maintenance: {
    label: 'Maintenance',
    tone: 'bg-amber-500/12 border-amber-500/25 text-amber-300',
    icon: <path d="M14.7 6.3a4 4 0 01-5.4 5.4L4 17v3h3l5.3-5.3a4 4 0 015.4-5.4l-2.6 2.6-2-2 2.6-2.6z" />,
  },
  announcement: {
    label: 'Announcement',
    tone: 'bg-sky-500/12 border-sky-500/25 text-sky-300',
    icon: <><path d="M3 11v2a1 1 0 001 1h2l5 4V6L6 10H4a1 1 0 00-1 1z" /><path d="M16 9a4 4 0 010 6" /><path d="M19 6a8 8 0 010 12" /></>,
  },
};

export default function AnnouncementBanner() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dismissing, setDismissing] = useState(null);

  useEffect(() => {
    api.get('/announcements/active')
      .then(res => setItems(res.data.announcements))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const dismiss = async (id) => {
    setDismissing(id);
    try {
      await api.post(`/announcements/${id}/dismiss`);
      setItems(prev => prev.filter(a => a.id !== id));
    } catch {
      // ha a kérés elbukik, a banner egyszerűen megmarad - a user újra próbálhatja
    } finally {
      setDismissing(null);
    }
  };

  if (loading || items.length === 0) return null;

  return (
    <div className="space-y-3 mb-8">
      {items.map(a => {
        const t = TYPES[a.type] || TYPES.announcement;
        return (
          <div key={a.id} className="card p-4 pr-3 flex items-start gap-3.5 animate-fade-up">
            <span className={`flex-shrink-0 w-9 h-9 rounded-lg border flex items-center justify-center ${t.tone}`}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"
                   strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
                {t.icon}
              </svg>
            </span>

            <div className="flex-1 min-w-0 py-0.5">
              <div className="flex items-center gap-2 mb-1.5">
                <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
                  {t.label}
                </span>
                <span className="w-1 h-1 rounded-full bg-gray-700" />
                <span className="text-[11px] text-gray-600 font-mono">{a.created_at?.slice(0, 10)}</span>
              </div>
              <h3 className="font-display font-semibold text-white text-[15px]">{a.title}</h3>
              <p className="text-sm text-gray-400 mt-1.5 leading-relaxed whitespace-pre-wrap">{a.content}</p>
            </div>

            <button
              onClick={() => dismiss(a.id)}
              disabled={dismissing === a.id}
              className="btn-icon flex-shrink-0"
              title="Dismiss"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" className="w-4 h-4">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        );
      })}
    </div>
  );
}
